import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, ChevronDown } from 'lucide-react';
import { PagesUpdatedArtifact } from '../types';
interface Props {
  artifact: PagesUpdatedArtifact;
  breadcrumb?: string;
  onViewInSession?: () => void;
}
export function PagesUpdatedCard({
  artifact,
  breadcrumb,
  onViewInSession
}: Props) {
  const [openFile, setOpenFile] = useState<string | null>(null);
  return <div className="bg-[#1c1c22] rounded-[16px] border border-white/[0.04] overflow-hidden" data-id="element-468">
      {breadcrumb && <div className="px-4 pt-3 text-[11px] text-[#8a8680]/60 tracking-wide" data-id="element-469">{breadcrumb}</div>}
      <div className="flex items-center gap-2 px-4 pt-3 pb-2" data-id="element-470">
        <FileText size={14} className="text-[#4a9a9a]" strokeWidth={1.5} data-id="element-471" />
        <span className="text-[11px] text-[#4a9a9a] uppercase tracking-wide" data-id="element-472">Pages updated</span>
        <span className="text-[11px] text-[#8a8680]/60 ml-auto" data-id="element-473">{artifact.timestamp}</span>
      </div>
      <div className="px-4 pb-3" data-id="element-474">
        <h3 className="text-[14px] text-[#e8e4df] mb-3" data-id="element-475">{artifact.title}</h3>
        <div className="space-y-1" data-id="element-476">
          {artifact.files.map(file => {
          const isOpen = openFile === file.path;
          return <div key={file.path} className="rounded-[10px] overflow-hidden" data-id="element-477">
                <button onClick={() => setOpenFile(isOpen ? null : file.path)} className="w-full flex items-center gap-3 px-3 py-2 bg-white/[0.02] hover:bg-white/[0.04] transition-colors text-left" data-id="element-478">
                  <ChevronDown size={12} className={`text-[#8a8680] transition-transform ${isOpen ? '' : '-rotate-90'}`} strokeWidth={1.5} data-id="element-479" />
                  <span className="text-[12px] text-[#e8e4df] font-mono flex-1 truncate" data-id="element-480">{file.path}</span>
                  <span className="text-[11px] text-[#4a9a9a]" data-id="element-481">+{file.added}</span>
                  <span className="text-[11px] text-[#e8a84c]" data-id="element-482">−{file.removed}</span>
                </button>
                <AnimatePresence data-id="element-483">
                  {isOpen && file.snippet && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-484">
                      <pre className="text-[11px] text-[#8a8680] font-mono px-3 py-2 bg-black/20 whitespace-pre-wrap" data-id="element-485">
                        {file.snippet}
                      </pre>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        {onViewInSession && <button onClick={onViewInSession} className="mt-3 text-[11px] text-[#8a8680] hover:text-[#4a9a9a] transition-colors" data-id="element-486">
            View in session →
          </button>}
      </div>
    </div>;
}